import React from "react";
import "./Video_Section.css";
import Common_Title from "../../common_components/common_title/Common_Title";

function Video_Section() {
  return (
    <section className="video_section container">
      <div className="title">
        <Common_Title title={<>Experience the Majesty Comfort</>} />
      </div>

      <div className="row">
        <div className="col-lg-9 col-md-10 col-12 mx-auto">
          <video
            className="video_wrapper"
            autoPlay
            loop
            muted
            controls
            playsInline
            onClick={(e) => e.target.requestFullscreen()}
          >
            <source
              src="/assets/images/home/video/majestry_video.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
}

export default Video_Section;